import Contracts, { ContractsListParams } from "@/getinfo-api/contracts";
import { Contract as IContract } from "@/api/models/contract";
import mutations from "@/store/modules/mutations";
import api from "@/getinfo-api";

export default {
  namespaced: true,
  state: {
    list: [] as Array<IContract>,
    count: 0,
    limit: 30,
    offset: 0
  },
  actions: {
    async LIST(ctx: any, params: ContractsListParams) {
      let myParams: ContractsListParams = {
        ...params,
        limit: ctx.state.limit,
        offset: ctx.state.offset
      };
      try {
        let response = await Contracts(myParams);
        ctx.commit("ADD_TO_LIST", response.data.items);
        ctx.commit("SET_COUNT", response.data.count);
        ctx.commit("INCREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    async REMOVE(ctx: any, id: string) {
      try {
        await api.ContractApi._delete(id);
        ctx.commit("REMOVE_FROM_LIST", id);
        ctx.commit("DECREASE_COUNT");
        ctx.commit("DECREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    }
  },
  mutations: {
    ...mutations.mutations
  },
  getters: {
    GET_LIST(state: any) {
      return state.list;
    },
    GET_COUNT(state: any) {
      return state.count;
    }
  }
};
